var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar'),_c('aside-menu',{attrs:{"menu":_vm.menu}}),_c('router-view',{staticStyle:{"min-height":"100vh"}}),_c('footer-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }